import React, { useRef, useCallback } from 'react';
import 'chartjs-adapter-moment';
import { FaChartBar, FaRegImage } from 'react-icons/fa';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import {Chart as ChartJS } from 'chart.js';
import 'chart.js/auto';

import { Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';


const Graph = (props) => {
    let ref = useRef(null);
   
    // Register the plugin to all charts:
    ChartJS.register(ChartDataLabels);

    const downloadImg = useCallback(() => {
      const link = document.createElement("a");
      link.download = props.site + " - " + props.title + ".png";
      link.href = ref.current.toBase64Image();
      link.click();
    },[props]);

    const plugin = {
      id: 'customCanvasBackgroundColor',
      beforeDraw: (chart, args, options) => {
        const {ctx} = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff'; // || options.color ;
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    };


    const chart = () => {
        return <Chart type={props.type} ref={ref} data={props.data} options={props.options} plugins={[plugin]} className='canvas_container' />

      }

    return (
        <Card>
        {(props.title)?
          <Card.Header>
              <div className='row'>
                <div className='col-md-8'>
                  <FaChartBar className="text-secondary"/> {props.title}
                </div>
                <div className='col-md-4 text-right'>
                  {props.subtitle} &nbsp;
                  <Button className='small p-1' variant="light" size="sm" onClick={downloadImg} >
                    <FaRegImage /> Download
                  </Button>
                </div>
              </div>
          </Card.Header>
        :''}
        <Card.Body>
         {chart()}
        </Card.Body>
        </Card>
        )
}

export default Graph;